import React from "react";
// import { useSelector } from 'react-redux';


export function Footer() {

    return (
      <div>
      </div>
    );
  
}

export default Footer

// const mapStateToProps = store => ({
//   fluid:
//     objectPath.get(store.builder.layoutConfig, "footer.self.width") === "fluid",
//   footerClasses: builder.selectors.getClasses(store, {
//     path: "footer",
//     toString: true
//   }),
//   footerContainerClasses: builder.selectors.getClasses(store, {
//     path: "footer_container",
//     toString: true
//   })
// });

// export default connect(mapStateToProps)(Footer);
